import toast, { type Renderable, type ValueOrFunction } from 'react-hot-toast';

// Custom toast wrapper that auto-dismisses previous toasts
export const showToast = {
  success: (message: string, options?: Parameters<typeof toast.success>[1]) => {
    toast.dismiss();
    return toast.success(message, options);
  },
  error: (message: string, options?: Parameters<typeof toast.error>[1]) => {
    toast.dismiss();
    return toast.error(message, options);
  },
  loading: (message: string, options?: Parameters<typeof toast.loading>[1]) => {
    toast.dismiss();
    return toast.loading(message, options);
  },
  custom: (
    message: ValueOrFunction<Renderable, unknown>,
    options?: Parameters<typeof toast>[1]
  ) => {
    toast.dismiss();
    return toast(message, options);
  },
};
